import { safety, comfort } from '@constants/values/equipmentTrailer'

const dodatkoweWyposazenie = { t: 'Dodatkowe wyposażenie', inputs: [
    { t: 'Bezpieczeństwo', type: 'multi-checkbox', name: 'bezpieczenstwo', options: safety },
    { t: 'Komfort', type: 'multi-checkbox', name: 'komfort', options: comfort },
]}

export default dodatkoweWyposazenie